export enum TimeFormat {
    TwelveHour = 0,
    TwentyFourHour = 1
}